<template>
    <div :class="{'pivot-offer': isPivot}">
        <span v-if="getOfferSellerName" class="no-wrap seller-name">({{ getOfferSellerName }})</span>
        <a v-if="getOfferParentLink" :href="getOfferParentLink" target="_blank" rel="noreferrer">
            <span class="no-wrap">{{ getOfferShopName }}</span>
        </a>
        <span v-else class="no-wrap">{{ getOfferShopName }}</span>
        <br/>
        <span v-if="isOfferBestseller" class="offer-component icon icon-detail icon-bestseller" v-popover:tooltip="t('Bestseller')"></span>
        <span v-if="isNewOffer" class="offer-component icon icon-detail icon-new-offer" v-popover:tooltip="t('New offer')"></span>
        <span v-if="isOfferPromotion" class="offer-component icon icon-detail icon-promotions" v-popover:tooltip="t('Product is on promotion') + ': ' + renderPromotion('name')"></span>
        <span v-if="isOfferPromotionCode" class="offer-component icon icon-detail icon-promotion-code" v-popover:tooltip="renderPromotion('code')"></span>
        <a target="_blank" :href="getOfferLink" rel="noreferrer">
            <span>{{ getOfferPrice }}</span>
        </a>
        <span class="strikethrough-price">{{ getOfferStrikeThroughPrice }}</span>
        <br/>
        <span v-if="getPricePercentDiff" :style="{color: getColor}"><small>({{ getPricePercentDiff }}%)</small></span>
    </div>
</template>

<script>

import ValueChecker from "@/services/ValueChecker";

export default
{
    components: {},
    props: {
        column: {
            type: Object,
            default: function() {
                return {
                    name: null,
                    data: null,
                }
            }
        },
        config: {
        },
        row: {
            type: Object,
        }
    },
    data() {
        return {

        };
    },
    computed: {
        getOfferShopName() {
            let offerShopNameIndex = `${this.column.data}_offer_shop_name`;

            return this.row[offerShopNameIndex];
        },
        getOfferParentLink() {
            let offerParentLinkIndex = `${this.column.data}_offer_parent_link`;

            return this.row[offerParentLinkIndex];
        },
        getOfferSellerName() {
            let sellerNameIndex = `${this.column.data}_offer_seller_name`;

            return this.row[sellerNameIndex];
        },
        getPricePercentDiff() {
            let pricePercentDiffIndex = `${this.column.data}_price_percent_diff`;

            return this.row[pricePercentDiffIndex];
        },
        getColor() {
            let colorIndex = `${this.column.data}_color`;

            return `#${this.row[colorIndex]}`;
        },
        getOfferLink() {
            let offerLinkIndex = `${this.column.data}_offer_link`;

            return this.row[offerLinkIndex];
        },
        getOfferPrice() {
            let offerPriceIndex = `${this.column.data}_price`;

            return this.row[offerPriceIndex];
        },
        getOfferStrikeThroughPrice() {
            let offerStrikeThroughPriceIndex = `${this.column.data}_strikethrough_price`;

            return this.row[offerStrikeThroughPriceIndex];
        },
        isOfferBestseller() {
            let offerBestsellerIndex = `${this.column.data}_bestseller`;

            return this.row[offerBestsellerIndex];
        },
        isNewOffer() {
            let newOfferIndex = `${this.column.data}_new_offer`;

            return this.row[newOfferIndex];
        },
        isOfferPromotion() {
            let offerPromotionIndex = `${this.column.data}_promotions`;

            return !ValueChecker.isUndefinedOrNullOrIsEmptyObject(this.row[offerPromotionIndex]);
        },
        isOfferPromotionCode() {
            let offerPromotionCodeIndex = `${this.column.data}_promotions`;

            return !ValueChecker.isUndefinedOrNullOrIsEmptyObject(this.row[offerPromotionCodeIndex]) && (this.row[offerPromotionCodeIndex] || []).filter(value => value['code']).length > 0;
        },
        isPivot() {
            let offerPivotIndex = `${this.column.data}_pivot`;

            return this.row[offerPivotIndex];
        }
    },
    mounted() {
    },
    methods: {
        renderPromotion(index) {
            let offerPromotionIndex = `${this.column.data}_promotions`;
            let promotions = this.row[offerPromotionIndex];
            let res = [];

            (promotions || []).forEach(value => {
                if (value[index]) {
                    res.push(value[index]);
                }
            });

            return res.join(',   ');
        }
    }
}
</script>

<style lang="sass" scoped>
@import "../../../node_modules/vue-slider-component/theme/default.css";
@import "src/assets/scss/variable.scss";
    .no-wrap {
        white-space: nowrap;
    }
    .offer-component {
        background-color: $main-background-color!important;
    }
    .offer-component:hover {
        background-color: green!important;
    }
</style>


// WEBPACK FOOTER //
// OfferComponent.vue?61ffc952